import { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";

export default function Balance() {
    const { transactions } = useContext(GlobalContext);
    const totalBalance = transactions.reduce((acc, cur) => cur.amount + acc, 0);

    const sign = totalBalance > 0 ? "+" : "-";

    return (
        <div className="total-balance">
            <h4>Available Balance</h4>
            <h1 className={totalBalance > 0 ? "grn-clr" : 'red-clr'}>
                {totalBalance ? `${sign} $${Math.abs(totalBalance)}` : '0.00'}
            </h1>
        </div>
    )
}
